import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={186}
            height={185}
            viewBox="0 0 186 185"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M19 92.5a74 74 0 10148.002 0A74 74 0 0019 92.5z"
            fill="#F2FAF9"
        />
        <path
            d="M111.114 132.253a9.125 9.125 0 01-9.126 9.126H54.665a9.118 9.118 0 01-8.43-5.632 9.119 9.119 0 01-.694-3.492V30.76a9.122 9.122 0 019.124-9.115h47.325a9.127 9.127 0 019.124 9.126v101.482z"
            fill="#fff"
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M51.242 38.74h54.17v84.107h-54.17V38.741z"
            fill={theme["#0D968F"]}
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M75.475 30.188l15.68-.002"
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M68.693 30.186a1.772 1.772 0 11-3.544.004 1.772 1.772 0 013.544-.004z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M73.338 132.112a4.986 4.986 0 003.08 4.61 5.002 5.002 0 003.819 0 5 5 0 002.7-2.701 4.988 4.988 0 00-6.519-6.519 5 5 0 00-2.7 2.701 4.986 4.986 0 00-.38 1.909zM60.688 77.94a4.384 4.384 0 108.768 0 4.384 4.384 0 00-8.769 0zM73.844 77.94a4.383 4.383 0 007.485 3.101 4.385 4.385 0 10-7.485-3.1zM86.996 77.94a4.384 4.384 0 108.769 0 4.384 4.384 0 00-8.769 0zM60.688 91.094a4.384 4.384 0 108.768 0 4.384 4.384 0 00-8.769 0zM73.844 91.094a4.384 4.384 0 108.767 0 4.384 4.384 0 00-8.767 0zM73.844 104.249a4.383 4.383 0 108.766.001 4.383 4.383 0 00-8.766-.001zM60.688 104.249a4.387 4.387 0 004.384 4.385 4.385 4.385 0 10-4.385-4.385zM58.496 51.63H97.96v13.155H58.496V51.63z"
            fill="#fff"
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M62.88 58.206a2.193 2.193 0 104.387 0 2.193 2.193 0 00-4.386 0zM71.648 58.206a2.193 2.193 0 104.386 0 2.193 2.193 0 00-4.386 0zM80.42 58.206a2.193 2.193 0 104.385 0 2.193 2.193 0 00-4.385 0zM89.19 58.206a2.192 2.192 0 104.384 0 2.192 2.192 0 00-4.385 0z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M121.902 50.973h35.979V81.33h-35.979V50.973z"
            fill={theme["#0D968F"]}
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M146.961 50.97v-6.29a7.06 7.06 0 00-2.029-5.073 7.071 7.071 0 00-7.77-1.562 7.06 7.06 0 00-3.832 3.895 7.08 7.08 0 00-.505 2.74v6.29H126.4v-6.29a13.493 13.493 0 0123.033-9.54 13.492 13.492 0 013.951 9.54v6.29h-6.423zM136.121 66.152a3.77 3.77 0 107.54 0 3.77 3.77 0 00-7.54 0z"
            fill="#fff"
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M104.672 123.634L89.142 97.31a4.749 4.749 0 118.18-4.825l11.912 20.197a4.752 4.752 0 018.187-4.827l1.206 2.044a4.74 4.74 0 01.296-5.267 4.738 4.738 0 013.13-1.846 4.743 4.743 0 014.753 2.289l1.206 2.046a4.747 4.747 0 011.7-6.466 4.748 4.748 0 016.481 1.641l8.746 14.826c6.215 10.545 3.212 14.8 6.766 20.82l3.317 5.624-23.525 13.869c-6.95-11.786-17.434-1.034-28.414-19.649-4.146-7.033-3.478-11.163 1.589-14.152z"
            fill="#fff"
        />
        <path
            d="M121.233 114.324l-2.612-4.43M112.853 118.809l-3.619-6.135M129.414 109.5l-1.408-2.385M110.1 132.838l-5.428-9.204M131.497 157.435c-6.95-11.786-17.434-1.034-28.414-19.649-4.146-7.03-3.478-11.159 1.589-14.149L89.142 97.31a4.749 4.749 0 118.18-4.825l11.912 20.197a4.752 4.752 0 018.187-4.827l1.206 2.044a4.74 4.74 0 01.296-5.267 4.738 4.738 0 013.13-1.846 4.743 4.743 0 014.753 2.289l1.206 2.046a4.747 4.747 0 011.7-6.466 4.748 4.748 0 016.481 1.641l8.746 14.826c6.215 10.545 3.212 14.8 6.766 20.82l3.317 5.624"
            stroke={theme["#0D968F"]}
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
    )
}

export default SvgComponent
